/**
 * assets/product-gallery.js
 * Gedrag van snippets/product-gallery.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

/*
 * Herbinding bij een section-re-render (theme-editor en Section Rendering
 * API): een via innerHTML ingevoegde <script src> voert NIET uit, dus de
 * init draait opnieuw zodra Shopify deze section herlaadt. De oude DOM-nodes
 * zijn dan weg, inclusief hun listeners, dus dit dupliceert niets.
 */
(function () {
  'use strict';

  function init() {
    (() => {
      /* ═══ MOBILE: Scroll-snap dot sync + click navigation + haptic ═══ */
      const mobileScroll = document.querySelector('[data-gallery-mobile]');
      const dots = document.querySelectorAll('[data-gallery-dot]');

      if (mobileScroll && dots.length > 0) {
        const slides = mobileScroll.querySelectorAll('[data-media-slide]');
        let currentIndex = 0;

        /* IntersectionObserver voor dot-sync (efficiënter dan scroll event) */
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              const idx = parseInt(entry.target.dataset.mediaSlide, 10);
              if (idx !== currentIndex) {
                currentIndex = idx;
                updateDots(idx);
                /* Haptic feedback bij snap */
                if ('vibrate' in navigator) navigator.vibrate(10);
              }
            }
          });
        }, {
          root: mobileScroll,
          threshold: 0.5
        });

        slides.forEach(slide => observer.observe(slide));

        function updateDots(activeIdx) {
          dots.forEach((dot, i) => {
            if (i === activeIdx) {
              dot.classList.remove('bg-slate-300');
              dot.classList.add('bg-navy', 'w-5');
            } else {
              dot.classList.remove('bg-navy', 'w-5');
              dot.classList.add('bg-slate-300');
            }
          });
        }

        /* Dot click → smooth scroll naar slide */
        dots.forEach(dot => {
          dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.galleryDot, 10);
            const target = slides[idx];
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          });
        });
      }

      /* ═══ DESKTOP: Thumbnail click → slide wisselen ═══ */
      const mainGallery = document.querySelector('[data-gallery-main]');
      const thumbs = document.querySelectorAll('[data-thumb]');

      if (mainGallery && thumbs.length > 0) {
        const desktopSlides = mainGallery.querySelectorAll('[data-slide]');

        thumbs.forEach(thumb => {
          thumb.addEventListener('click', () => {
            const idx = parseInt(thumb.dataset.thumb, 10);

            /* Slides tonen/verbergen */
            desktopSlides.forEach((slide, i) => {
              slide.classList.toggle('hidden', i !== idx);
            });

            /* Active state op thumbnails */
            thumbs.forEach((t, i) => {
              if (i === idx) {
                t.classList.remove('border-transparent', 'opacity-60');
                t.classList.add('border-navy', 'opacity-100');
              } else {
                t.classList.remove('border-navy', 'opacity-100');
                t.classList.add('border-transparent', 'opacity-60');
              }
            });
          });
        });

        /* Desktop zoom: klik op main image → lightbox */
        mainGallery.addEventListener('click', (e) => {
          const lightbox = document.getElementById('zoom-lightbox');
          if (!lightbox) return;
          const img = e.target.closest('.pdp-zoom-wrap img, .pdp-zoom-img');
          if (!img) return;
          const lbImg = lightbox.querySelector('[data-zoom-lightbox-img]');
          if (lbImg) {
            lbImg.src = img.src;
            lbImg.alt = img.alt;
          }
          lightbox.showModal();
        });
      }
    })();
  }

  init();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-gallery-mobile], [data-gallery-thumb]')) init();
  });
})();
